<template>
    <van-dialog
        class="dialog"
        v-model="isShow"
        title="请留言"
        confirm-button-text="提交留言"
        show-cancel-button
        :before-close="beforeClose"
        @confirm="confirm"
        @close="close">
        <div class="dialog__content">
            <div class="tips">抱歉，我们暂时无法为您提供服务。如需帮助，请留言，我们将尽快联系并解决您的问题。</div>
            <div class="form">
                <div class="form__item" v-if="config.tag.select">
                    <div class="form__label">问题类型</div>
                    <treeselect v-model="tag" :options="tagList" :normalizer="$tag.normalizer" placeholder="请选择" @input="validator('tag')" noResultsText="无匹配数据" noOptionsText="无匹配数据" loadingText="正在加载" disableBranchNodes>
                        <div slot="value-label" slot-scope="{ node }">{{$tag.labelName(node)}}</div>
                    </treeselect>
                    <p class="frm-err" v-if="err.parentTag">{{err.parentTag}}</p>
                </div>
                <div class="form__item">
                    <div class="form__label">问题描述</div>
                    <textarea
                        class="form__income"
                        v-model="desc"
                        @blur="validator('desc')"
                        placeholder="请详细描述你所遇到的问题 (不超过50个字)"
                        rows="3"
                        maxlength="50"></textarea>
                    <p class="frm-err" v-if="err.desc">{{err.desc}}</p>
                </div>
                <div class="form__item">
                    <van-uploader
                        name="file"
                        accept=""
                        :before-read="beforeRead"
                        :after-read="afterRead">
                        <button class="upload-btn">上传文件</button>
                        <p class="upload-tips">{{fileName}}</p>
                    </van-uploader>
                </div>
                <div class="form__item" v-if="config.name.select">
                    <div class="form__label">姓名</div>
                    <input
                        class="form__income"
                        type="text"
                        @blur="validator('name')"
                        placeholder="请输入"
                        maxlength="15"
                        v-model="name">
                    <p class="frm-err" v-if="err.name">{{err.name}}</p>
                </div>
                <div class="form__item" v-if="config.phone.select">
                    <div class="form__label">联系电话</div>
                    <input
                        ref="mobile"
                        class="form__income"
                        @blur="validator('mobile')"
                        placeholder="请输入"
                        v-model="mobile">
                    <p class="frm-err" v-if="err.mobile">{{err.mobile}}</p>
                </div>
                <div class="form__item" v-if="config.email.select">
                    <div class="form__label">邮箱</div>
                    <input
                        class="form__income"
                        type="text"
                        @blur="validator('email')"
                        placeholder="请输入"
                        v-model="email">
                    <p class="frm-err" v-if="err.email">{{err.email}}</p>
                </div>
            </div>
        </div>
    </van-dialog>
</template>

<script>
    // import get from 'lodash.get'
    import { levelUploadFile } from '@/api/upload'
    import { postLeaveMessage, getServiceTag, getLeaveMsgConf } from '@/api/leave_message'
    import { SHOW_LEAVE_MESSAGE_DIALOG } from '@/constants/pub_sub'
    import { isEmail } from '@/utils'
    import { pattern } from '@/utils/pattern'
    import { isValidFileSize } from '@/utils/upload'

    export default {
        name: 'TheLeaveMessageDialog',
        data () {
            return {
                isShow: false,
                desc: '',
                name: '',
                email: '',
                mobile: '',
                uploads: [],
                tag: null,
                tagList: [],
                err: {
                    desc:'',
                    name:'',
                    email:'',
                    mobile:'',
                    parentTag:''
                },
                config: {
                    tag: {select: true, must: true},
                    name: {select: true, must: true},
                    email: {select: true, must: true},
                    phone: {select: true, must: true}
                },
                fileName: ''
            }
        },
        // computed: {
        //     fileName () {
        //         return get(this.uploads, '0.name', '')
        //     }
        // },
        watch: {
            isShow (value) {
                if (value) {
                    this.setServiceTag()

                    this.err = {
                        desc:'',
                        name:'',
                        email:'',
                        mobile:'',
                        parentTag:''
                    }
                }
            },
        },
        methods: {
            async init () {
                console.log('local search', window.location.search)
                const pam = window.location.search.slice(1).split('&').find(x => x.split('=')[0] === 'e')
                let code = this.$eventBus.companyCode
                this.config = await getLeaveMsgConf({
                    code,
                    entry_id: pam ? pam.split('=')[1] : ''
                })
            },
            getShowProp () {
                let prop = 'desc'
                let conf = this.config
                if (conf.tag.select) {
                    prop+=',tag'
                }
                if (conf.name.select) {
                    prop+=',name'
                }
                if (conf.email.select) {
                    prop+=',email'
                }
                if (conf.phone.select) {
                    prop+=',mobile'
                }
                return prop
            },
            validator (prop) {
                let err = this.err
                let config = this.config
                // let parentTag = this.parentTag + ''
                prop = prop || this.getShowProp()
                let valid, valid2, valid3 = false
                if (!this.mobile && this.$refs.mobile) {
                    this.$refs.mobile.value = ''
                }
                if (prop.indexOf('tag')>=0 ) {
                    // if (config.tag.must && parentTag.trim() === '') {
                    if (config.tag.must && !this.tag) {
                        err.parentTag = '请输入问题类型'
                        valid = true
                    } else {
                        err.parentTag = ''
                    }
                }
                if (prop.indexOf('desc')>=0) {
                    if ( this.desc.trim() === '') {
                        err.desc = '请输入问题描述'
                        valid = true
                    } else {
                        err.desc = ''
                    }
                }
                if (prop.indexOf('name')>=0 ) {
                    if (config.name.must && this.name.trim() === '') {
                        err.name = '请输入姓名'
                        valid = true
                    } else {
                        err.name = ''
                    }
                }
                if (prop.indexOf('mobile')>=0) {
                    let mobile = this.mobile || ''
                    if (config.phone.must && mobile.trim() === '') {
                        err.mobile = '请输入联系电话'
                        valid2 = true
                    }
                    // if (mobile && !isPhoneNumber(mobile)) {
                    if (mobile && !pattern('tel').test(mobile)) {
                        err.mobile = '电话号码有误'
                        valid2 = true
                    }
                    if (!valid2) {
                        err.mobile = ''
                    }
                }
                if (prop.indexOf('email')>=0) {
                    let email = this.email || ''
                    if(config.email.must && email.trim() === '') {
                        err.email = '请输入邮箱'
                        valid3 = true
                    }
                    if (email && (!/^[a-zA-Z0-9@.]+$/.test(email)||!isEmail(email))) {
                        err.email = '邮箱有误'
                        valid3 = true
                    }
                    if (!valid3) {
                        err.email = ''
                    }
                }
                if (this.uploads.length >= 2) {
                    this.$toast('上传文件个数不能大于1个')
                    valid = true
                }
                return valid||valid2||valid3
            },
            async confirm () {
                if (this.validator()) {
                    return
                }
                try {
                    await postLeaveMessage({
                        uid: this.$eventBus.uid,
                        tag: this.tag,
                        desc: this.desc,
                        name: this.name,
                        email: this.email || null,
                        mobile: this.mobile,
                        uploads: this.uploads
                    })
                    this.$toast('提交留言成功')
                    this.isShow = false
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                }
            },
            reset () {
                this.desc = ''
                this.name = ''
                this.email = ''
                this.mobile = ''
                this.uploads = []
                this.tagList = []
                this.fileName = ''
            },
            beforeClose (action, done) {
                done(action !== 'confirm')
            },
            close () {
                this.reset()
            },
            beforeRead (file) {
                const validFileSizeErrorString = isValidFileSize(file, file.size)
                if (validFileSizeErrorString) {
                    this.$toast.fail(validFileSizeErrorString)
                    return false
                }
                return true
            },
            async afterRead ({ file }) {
                try {
                    const fileList = await levelUploadFile(file) // 全渠道上传
                    this.uploads = fileList.map(item => item.attachmentId)
                    this.fileName = file.name
                    // const { url } = await levelUploadFile(file)
                    // this.uploads = [{
                    //     name: file.name,
                    //     size: file.size,
                    //     type: file.type,
                    //     url
                    // }]
                    this.$toast.success('上传成功')
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                    this.$toast.fail('上传失败')
                }
            },
            async setServiceTag () {
                this.tagList = this.$tag.clearEmptyChild(await getServiceTag(this.$eventBus.entryKey))
            }
        },
        created () {
            this.$eventBus.$on(SHOW_LEAVE_MESSAGE_DIALOG, () => {
                this.isShow = true
            })
            this.init()
        },
        beforeDestroy () {
            this.$eventBus.$off(SHOW_LEAVE_MESSAGE_DIALOG)
        }
    }
</script>

<style lang="scss" scoped>
    .dialog {
        top: 50%;
    }

    .dialog__content {
        text-align: center;
        padding: percent(15, 320) 0;
    }

    .tips {
        font-size: 12px;
        color: #333;
        padding: 0 percent(15, 320);
    }

    .form {
        margin-top: percent(10, 320);

        &__item {
            padding: 0 percent(15, 320);
            text-align: left;
            margin: percent(10, 320) 0;

            &:last-child {
                margin-bottom: 0;
            }
        }

        &__label {
            color: #555;
            font-size: 14px;
        }

        &__income {
            display: block;
            width: 100%;
            border-radius: 4px;
            border: 1px solid #d8d8d8;
            font-size: 14px;
            padding: 5px;
            line-height: (20 / 14);
        }

        &__tips {
            font-size: 12px;
            color: #666;
        }
        .frm-err {
            font-size: 12px;
            color: #ff0000;
        }
    }

    .upload-btn {
        padding: 4px 16px;
        border: 1px solid #b3b3b3;
        border-radius: 4px;
        background-color: #fff;
        white-space: nowrap;
        font-size: 14px;
    }

    .upload-tips {
        display: inline-block;
        font-size: 12px;
        margin-left: 5px;
        color: #666;
        @include text-line;
    }

    textarea {
        resize: none;
        outline: none;
        appearance: none;
    }

    select.form__income {
        display: inline-block;
        width: auto;
        max-width: 100%;
        background-color: #fff;
        vertical-align: top;

        option {
            &:nth-child(n + 2) {
                color: #333;
            }
        }
    }

    .van-uploader {
        display: block;
    }

    /deep/.van-uploader__input-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .vue-treeselect {
        margin-top: 4px;
        font-size: 12px;
    }
</style>
